/* APP-ME · FASHION · el carrusel de «Tres formas de usarla»
 *
 * Antes era una animación CSS sobre un contenedor con `overflow:hidden`: se movía
 * solo, pero el dedo no podía tocarlo —literalmente no había nada que desplazar— y
 * pasar el ratón por encima lo congelaba. Pedido del jefe: poder adelantarlo con el
 * dedo, y que NO se quede parado.
 *
 * Ahora el contenedor es un desplazador de verdad (`overflow-x:auto`), así que el dedo
 * lo mueve con la inercia del sistema, y este guion lo va empujando solo. Mientras el
 * dedo está encima no empuja —si no, pelearía con el arrastre— y en cuanto la inercia
 * para, sigue. Nunca se queda quieto.
 *
 * Vive en el tema y el preview lo inyecta tal cual: escrito dos veces, el consultor
 * aprobaría un carrusel y la tienda publicaría otro.
 */
(function () {
  'use strict';

  var VELOCIDAD = 70;    // píxeles por segundo del empuje automático
  var ESPERA = 900;      // ms de cortesía tras soltar, para que la inercia termine

  function arrancar(vp) {
    if (vp.getAttribute('data-me-fa-carrusel') === 'listo') { return; }
    vp.setAttribute('data-me-fa-carrusel', 'listo');

    var carril = vp.querySelector('.me-fa-styling__track');
    if (!carril) { return; }

    // La copia de las tarjetas es la que hace el bucle sin costura: al avanzar una
    // tanda entera se descuenta, y el salto no se ve porque lo que hay delante es
    // idéntico.
    //
    // OJO CON EL ANCHO: `scrollLeft` no puede pasar de `scrollWidth - clientWidth`. Si
    // la tanda es más ancha que lo que se puede desplazar —pantalla ancha, tarjeta del
    // panel— el punto de salto queda FUERA DE ALCANCE: el carril llega al final y se
    // queda ahí para siempre. Pasó: en el móvil se movía y en el panel avanzaba 0 px.
    // Por eso se añaden tandas hasta que el salto sea alcanzable.
    var dup = carril.querySelector('.me-fa-styling__dup');
    var primera = carril.firstElementChild;
    var unidad = (dup && primera) ? (dup.offsetLeft - primera.offsetLeft) : 0;
    if (unidad > 0 && dup) {
      var guarda = 0;
      while (carril.scrollWidth - unidad < vp.clientWidth && guarda < 8) {
        carril.appendChild(dup.cloneNode(true));
        guarda++;
      }
    }
    var mitad = function () {
      return unidad > 0 ? unidad : carril.scrollWidth / 2;
    };

    // «Reducir movimiento» del sistema: NO lo deja quieto, lo lleva a la mitad de
    // velocidad. Con la versión anterior el carrusel no se movía en absoluto en un
    // teléfono con ese ajuste puesto —que en iPhone viene activado en mucha gente— y
    // esa tira ES el contenido: la ocasión de uso que no gira no se ve nunca. Se
    // suaviza en vez de apagarse.
    var suave = !!(window.matchMedia &&
                   window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var arrastrando = false;
    var reanudarEn = 0;
    var anterior = 0;
    // LA POSICIÓN SE LLEVA APARTE, en un número con decimales.
    // `scrollLeft` está cuantizado a enteros en muchas páginas (medido en la tienda: un
    // empujón de 0,5 px devuelve 1). El empuje de un fotograma es menos de un píxel, así
    // que sumárselo directamente deja el resultado en manos de cómo redondee cada
    // navegador: en uno avanza y en otro se queda clavado en cero. Eso es lo que se veía
    // como «en la plataforma se mueve y en la tienda no».
    var pos = 0;
    var resincronizar = true;

    function tocando() {
      arrastrando = true;
      reanudarEn = 0;
      resincronizar = true;   // el dedo manda: al volver se parte de donde lo dejó
    }
    function soltado() {
      arrastrando = false;
      reanudarEn = Date.now() + ESPERA;
      resincronizar = true;
    }

    // `passive: true`: no se llama a preventDefault en ninguno, y así el navegador no
    // tiene que esperar a este guion para empezar a desplazar. Sin esto el arrastre se
    // siente pegajoso, que es justo lo contrario de lo que se pidió.
    ['pointerdown', 'touchstart', 'mousedown'].forEach(function (ev) {
      vp.addEventListener(ev, tocando, { passive: true });
    });
    ['pointerup', 'pointercancel', 'touchend', 'touchcancel', 'mouseup', 'mouseleave']
      .forEach(function (ev) { vp.addEventListener(ev, soltado, { passive: true }); });
    // La rueda del ratón y el trackpad no dan pointerdown: se tratan como un empujón
    // suelto, con la misma cortesía antes de seguir.
    vp.addEventListener('wheel', function () {
      reanudarEn = Date.now() + ESPERA;
      resincronizar = true;
    }, { passive: true });

    function paso(ahora) {
      var dt = anterior ? Math.min(ahora - anterior, 100) : 0;
      anterior = ahora;

      var m = mitad();
      if (m > 0) {
        if (!arrastrando && Date.now() >= reanudarEn) {
          // Se parte de donde está de verdad solo cuando alguien lo movió; el resto del
          // tiempo manda `pos`, que lleva los decimales que `scrollLeft` no guarda.
          if (resincronizar) { pos = vp.scrollLeft; resincronizar = false; }
          pos += (suave ? VELOCIDAD / 2 : VELOCIDAD) * dt / 1000;
          // El bucle vale en los dos sentidos: si el dedo lo lleva hacia atrás más allá
          // del principio, se salta a la copia de delante en vez de chocar contra el
          // borde.
          if (pos >= m) { pos -= m; }
          else if (pos < 0) { pos += m; }
          vp.scrollLeft = pos;
        } else if (!arrastrando) {
          // Mientras está en pausa por el dedo, el bucle sigue vigilando: si el
          // arrastre lo llevó más allá de la costura, se recoloca igual.
          if (vp.scrollLeft >= m) { vp.scrollLeft -= m; resincronizar = true; }
          else if (vp.scrollLeft <= 0) { vp.scrollLeft += m; resincronizar = true; }
        }
      }
      window.requestAnimationFrame(paso);
    }
    // Arranca un pelo dentro para que el bucle hacia atrás tenga sitio desde el primer
    // momento; si empieza en 0, el primer deslizamiento a la derecha topa con el borde.
    vp.scrollLeft = 1;
    window.requestAnimationFrame(paso);
  }

  // ── LOS PUNTOS DEL CARRUSEL DE VISTAS ──
  // Se pintaban con el primero marcado y NADIE los volvía a tocar: daba igual qué vista
  // estuvieras mirando, el punto encendido era siempre el uno. Él lo vio en la
  // plataforma y en la tienda, porque los dos caminos pintan el mismo marcado.
  //
  // No se puede resolver solo con CSS: `scroll-snap` mueve el carril pero no deja
  // ninguna marca en el DOM de en qué diapositiva se paró.
  function seguirPuntos(car) {
    var caja = car.parentElement && car.parentElement.querySelector('.me-fa-views__puntos');
    if (!caja || !caja.children.length) { return; }
    var bolas = caja.children;
    var ultimo = -1;

    function pintar() {
      // El índice sale de la POSICIÓN, no de un contador propio: con el dedo se puede
      // saltar dos diapositivas de un gesto, y un contador se desincroniza en cuanto
      // eso pasa. `clientWidth` es el ancho de UNA diapositiva porque cada una ocupa
      // el 100% del carril.
      var ancho = car.clientWidth || 1;
      var i = Math.round(car.scrollLeft / ancho);
      if (i < 0) { i = 0; }
      if (i > bolas.length - 1) { i = bolas.length - 1; }
      // El guardia es el índice, no un `requestAnimationFrame`. El evento `scroll` llega
      // decenas de veces por gesto, pero comparar un número y salir es más barato que
      // pedir un cuadro — y además NO depende de que el navegador esté pintando: en una
      // pestaña de fondo `requestAnimationFrame` se para y los puntos se quedaban
      // congelados en el uno.
      if (i === ultimo) { return; }
      ultimo = i;
      for (var n = 0; n < bolas.length; n++) {
        var on = (n === i);
        bolas[n].classList.toggle('me-fa-views__punto--on', on);
        bolas[n].setAttribute('aria-current', on ? 'true' : 'false');
      }
    }

    car.addEventListener('scroll', pintar, { passive: true });

    // Y de paso se pueden PULSAR, que es lo que cualquiera intenta al verlos.
    for (var n = 0; n < bolas.length; n++) {
      (function (idx, bola) {
        bola.setAttribute('role', 'button');
        bola.setAttribute('tabindex', '0');
        bola.setAttribute('aria-label', 'Ver la vista ' + (idx + 1));
        function ir() { car.scrollTo({ left: idx * car.clientWidth, behavior: 'smooth' }); }
        bola.addEventListener('click', ir);
        bola.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); ir(); }
        });
      })(n, bolas[n]);
    }
    pintar();
  }

  function init() {
    var vps = document.querySelectorAll('.me-fa-styling__viewport');
    for (var i = 0; i < vps.length; i++) { arrancar(vps[i]); }
    var cars = document.querySelectorAll('.me-fa-views__car');
    for (var j = 0; j < cars.length; j++) { seguirPuntos(cars[j]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // En el editor del tema las secciones se recargan sueltas, sin volver a cargar la
  // página: sin esto el carrusel queda muerto mientras el consultor edita.
  document.addEventListener('shopify:section:load', init);
})();
